import { render } from "./WaitingListAdd.vue?vue&type=template&id=854d577e"
import script from "./WaitingListAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitingListAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WaitingListAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "854d577e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('854d577e', __exports__)) {
    api.reload('854d577e', __exports__)
  }
  
  module.hot.accept("./WaitingListAdd.vue?vue&type=template&id=854d577e", () => {
    api.rerender('854d577e', render)
  })

}


export default __exports__